import { render, staticRenderFns } from "./desk-phone-row.vue?vue&type=template&id=02ea84cb"
import script from "./desk-phone-row.vue?vue&type=script&lang=js"
export * from "./desk-phone-row.vue?vue&type=script&lang=js"
import style0 from "./desk-phone-row.vue?vue&type=style&index=0&id=02ea84cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports